import React from 'react';
import { useDeviceType } from '@cian/ui-kit';
import { ActionButton } from '../ActionButton';
import styles from './styles.css';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var FormActions = function FormActions(_ref) {
  var onCancel = _ref.onCancel,
    onSubmit = _ref.onSubmit,
    isSubmitDisabled = _ref.isSubmitDisabled;
  var deviceType = useDeviceType();
  return /*#__PURE__*/_jsxs("div", {
    className: styles['actions'],
    children: [/*#__PURE__*/_jsx(ActionButton, {
      type: "button",
      "data-testid": "leave-contacts-modal-cancel-button",
      theme: deviceType === 'phone' ? 'fill_secondary' : 'fill_white_primary',
      onClick: onCancel,
      children: "\u041E\u0442\u043C\u0435\u043D\u0438\u0442\u044C"
    }), /*#__PURE__*/_jsx(ActionButton, {
      type: "submit",
      "data-testid": "leave-contacts-modal-submit-button",
      onClick: onSubmit,
      disabled: isSubmitDisabled,
      children: "\u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C"
    })]
  });
};